import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function PinterestIcon({
	width,
	height,
	active = false,
	'aria-label': ariaLabel = 'Pinterest',
	style,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30,30,30,.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>Pinterest</title>
			<rect width="40" height="40" rx="8" fill={bg} />
			<path
				d="M133-247C-8.4-247-123-132.4-123 9c0 108.5 67.5 201.2 162.7 238.5-2.2-20.3-4.3-51.4.9-73.5 4.7-20 30-127.2 30-127.2s-7.7-15.3-7.7-38c0-35.6 20.6-62.2 46.3-62.2 21.8 0 32.4 16.4 32.4 36.1 0 22-14 54.8-21.2 85.2-6 25.5 12.8 46.3 37.9 46.3 45.5 0 80.5-48 80.5-117.2 0-61.3-44-104.2-106.9-104.2C59-107.3 16.3-52.7 16.3 3.8c0 22 8.5 45.6 19.1 58.4 2.1 2.5 2.4 4.8 1.8 7.3-1.9 8.1-6.3 25.5-7.1 29-1.1 4.7-3.7 5.7-8.6 3.4-32-14.9-52-61.6-52-99.2 0-80.8 58.7-154.9 169.1-154.9 88.8 0 157.8 63.3 157.8 147.9C296.4 84 240.8 155 163.6 155c-25.9 0-50.3-13.5-58.7-29.4 0 0-12.8 48.9-15.9 60.9-5.8 22.2-21.4 50.1-31.8 67.1 24 7.4 49.4 11.4 75.8 11.4 141.4 0 256-114.6 256-256S274.3-247 133-247"
				fill={g}
				transform="translate(20 20) scale(0.06) translate(-133 -9)"
			/>
		</svg>
	);
}
